import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {CellComponent} from '@spartacus/organization/administration/components';
import { RouterLink } from '@angular/router';
import { PopoverDirective } from '@spartacus/storefront';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-group-details-cell',
    templateUrl: './efa-user-group-details-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, PopoverDirective, TranslatePipe, UrlPipe]
})
export class EfaUserGroupDetailsCellComponent extends CellComponent{
}
